export default __webpack_public_path__ + "static/media/Pin.58938561.svg";